
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import FAQ from './components/FAQ';
import Terms from './components/Terms';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <img 
                src="https://public.readdy.ai/ai/img_res/9351db98-9473-4ed8-9f5c-c80587259950.png" 
                alt="LACOJEC LTDA Logo" 
                className="h-12 w-auto"
              />
            </div>
            <div className="hidden md:flex items-center space-x-8">
              <button 
                onClick={() => scrollToSection('home')}
                className={`transition-colors cursor-pointer whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
                }`}
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className={`transition-colors cursor-pointer whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
                }`}
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className={`transition-colors cursor-pointer whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
                }`}
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className={`transition-colors cursor-pointer whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
                }`}
              >
                Contact
              </button>
              <button 
                onClick={() => scrollToSection('faq')}
                className={`transition-colors cursor-pointer whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
                }`}
              >
                FAQ
              </button>
              <button 
                onClick={() => scrollToSection('terms')}
                className={`transition-colors cursor-pointer whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-teal-500' : 'text-white hover:text-teal-300'
                }`}
              >
                Terms
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Sections */}
      <div id="home">
        <Hero scrollToContact={() => scrollToSection('contact')} />
      </div>
      <div id="about">
        <About />
      </div>
      <div id="services">
        <Services />
      </div>
      <div id="contact">
        <Contact />
      </div>
      <div id="faq">
        <FAQ />
      </div>
      <div id="terms">
        <Terms />
      </div>
      <Footer scrollToSection={scrollToSection} />
    </div>
  );
}
